import React from "react";
import "./about.css";
import pawImg from '../assets/paw.png';


const About: React.FC = () => {
  return (
    <div className="page-container cream-bg">
      {/* Floating Paw Print Background */}
      <div className="hero-paw-bg">
        <img src={pawImg} className="hero-paw-float paw1" alt="" />
        <img src={pawImg} className="hero-paw-float paw2" alt="" />
        <img src={pawImg} className="hero-paw-float paw3" alt="" />
        <img src={pawImg} className="hero-paw-float paw4" alt="" />
        <img src={pawImg} className="hero-paw-float paw5" alt="" />
        <img src={pawImg} className="hero-paw-float paw6" alt="" />
        <img src={pawImg} className="hero-paw-float paw7" alt="" />
      </div>
      <section className="page-intro">
        <h1 className="page-title">About ChowMeDown</h1>
        <div className="page-intro-underline" />
        <p className="page-intro-desc">
          ChowMeDown helps dog owners create homemade, nutritious meals with ease. 
          Inspired by real experiences and built out of love for pets, it’s here to make 
          healthy feeding simple, affordable, and fun.
        </p>  
        <div className="about-values">
          <div className="value">
            🐾 <h3>Health First</h3>
            <p>Human grade food</p>
          </div>
          <div className="value">
            🍲 <h3>Easy Recipes</h3>
            <p>Based on ingredients you already have or can easily find</p>
          </div>
          <div className="value">
            ❤️ <h3>Inspired by Maggie</h3>
            <p>A story that started with one dog</p>
          </div>
        </div>
      </section>

      {/* Journey */}
      <section className="about-journey-intro">
        <h2>Our Journey</h2>
        <div className="timeline">
          <div className="timeline-item left">
            <div className="content">
              <h3>2016 – Roscoe's Allergies</h3>
              <p>
                Hello, my name is Alannah. In 2016, my roommate's dog Roscoe continued to have allergic reactions to commercial dog food. Since we did not have a lot of spending money, the prescription dog food that veterinarians suggested was not an option. I remember thinking, how hard could it be to make dog food? We make food for babies - why not for dogs? So I decided to try making homemade meals for him myself. After a few weeks, Roscoe’s allergies started clearing up. That’s when I was hooked.
              </p>
              <img src={require('../assets/first-food.JPG')} alt="Roscoe the dog" className="timeline-photo" />
            </div>
          </div>
          <div className="timeline-item right">
            <div className="content">
              <h3>2017 – Learning & Experimenting</h3>
              <p>
                I started doing more research and began my journey into learning about canine nutrition. I found that there was a lot of dog food sold in stores that was not healthy for dogs. I started to make all kinds of different recipes for Roscoe. Some years passed and my roommate moved away and took Roscoe with them, but not before I found Maggie.
              </p>
            </div>
          </div>
          <div className="timeline-item left">
            <div className="content">
              <h3>2018 – Maggie's Story</h3>
              <p>
                I got Maggie at 9 months old and I was not sure why anyone would want to give her away. Later, I saw she was having constant UTIs. After a few vet visits and tests, they found out she had bladder stones. Then I decided I would start to make her food from scratch like I had done for Roscoe. After a few months of making her food and her stones dissolving, I was hooked again.
              </p>
              <img src={require('../assets/maggie-me-first.JPG')} alt="Maggie the dog" className="timeline-photo" />
            </div>
          </div>
          <div className="timeline-item right">
          <div className="content">
              <h3>2019 – ChowMeDown YouTube</h3>
              <p>
                That’s when I decided to start a YouTube channel to share my recipes, and ChowMeDown was born. For a few years, I created and shared homemade dog food recipes on the channel. At the time, I was in college exploring different career paths. While working on the channel, I started thinking about how helpful it would be to have a tool that could make homemade dog food recipes easier to create, adjust, and follow. That idea eventually led me to pursue software development so I could build this application myself. What started as a way to build this project turned into something I truly enjoy doing.
              </p>
              <img src={require('../assets/maggie-at-table-wth-food.JPG')} alt="Maggie at table with food" className="timeline-photo" />
              <img src={require('../assets/youtube-maggie.PNG')} alt="ChowMeDown YouTube logo" className="timeline-photo" />
            </div>
          </div>
          <div className="timeline-item left">
            <div className="content">
              <h3>2021 – Traveling & Inspiration</h3>
              <p>
                After graduating, I took some time off to travel the world, of course taking Maggie with me, and then settled in Europe. Making dog food was not an easy task as I was not accustomed to all the stores and did not want to spend an arm and a leg on ingredients. The point of homemade dog food is for the costs to be manageable and the quality of the food to be good.
              </p>
              <img src={require('../assets/Maggie-enjoying.JPG')} alt="Maggie traveling" className="timeline-photo" />
              <img src={require('../assets/Maggie-germany.png')} alt="Maggie traveling" className="timeline-photo" />
            </div>
          </div>
          <div className="timeline-item right">
            <div className="content">
              <h3>2025 – ChowMeDown App</h3>
              <p>
                I took a few years off making dog food, working as a software engineer and honing my skills. In 2025, I decided to pick up where I left off and combine my two passions of dogs and coding.
              </p>
              <img src={require('../assets/Lean-Kangaro-Rice-Medley-maggie.jpg')} alt="Lean Kangaro Rice Medley with Maggie" className="timeline-photo" />
              <img src={require('../assets/maggie-now-with-food.JPG')} alt="Homemade dog food ingredients" className="timeline-photo" />
            </div>
          </div>
          <div className="timeline-item left">
            <div className="content">
              <h3>2026 – ChowMeDown App Launch</h3>
              <p>
                Launching ChowMeDown, a web application that helps pet owners make healthy and safe meals for their dogs, has been one of my proudest achievements. I hope you enjoy it as much as I do. Thanks for reading my story.              
              </p>
              <img src={require('../assets/siteLogo.png')} alt="ChowMeDown app logo" className="about-logo" />
            </div>
          </div>
        </div>
      </section>
      <h2 className="about-journey-intro rest-future-title">The rest is future</h2>
      {/* Bug report section */}
      <section className="bug-report-section" style={{ marginTop: 48, padding: '2em 0', background: '#fffbe6', borderRadius: 12, textAlign: 'center' }}>
        <h3 style={{ color: '#c14444', marginBottom: 8 }}>Found a bug?</h3>
        <p style={{ fontSize: 16, color: '#333', maxWidth: 500, margin: '0 auto' }}>
          If you notice any bugs or issues, please email me at <a href="mailto:chowmedown321@gmail.com" style={{ color: '#c14444', textDecoration: 'underline' }}>chowmedown321@gmail.com</a>.<br />
          I appreciate your help and will do my best to address it quickly. Thank you!
        </p>
      </section>
    </div>
  );
};

export default About;
